global.version = "1.0.1";
global.toggle = false;
global.api = "https://legalentitybackend-master-mk2ypemvbq-as.a.run.app/";
// global.api = "https://r636x5f3-8080.asse.devtunnels.ms/";
global.bot_token = "8021861597:AAHULvgkpp9cTw6uwKdWrnNRGeXL9yephJc";
global.service_status = [
    "รอตอบรับ",
    "รับงานแล้ว",
    "สำเร็จ",
    "ยกเลิก"
]